import { render } from '@wordpress/element';
import AdminTab from './components/Tabs/adminTab';

document.addEventListener('DOMContentLoaded', () => {
    const rootElement = document.getElementById('dssfw_admin_app');
    if (rootElement) {
        render(<AdminTab />, rootElement);
    }
});